import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';

export const Background = styled.div`
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.16), rgba(45, 86, 150, 0.16));
`;

export const Wrapper = styled.div`
  color: #2d5696;
  background-color: white;
  max-width: 451px;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 0 59px 10px rgba(0, 0, 0, 0.57);
  border-radius: 2px;
  padding: 0;
  margin: 20px auto 25px;
`;

export const FullHeightRow = styled(Row)`
  min-height: 100%;
`;

export const FullHeightCol = styled(Col)`
  min-height: 100%;
`;



// WEBPACK FOOTER //
// ./src/views/common/components/Paper/styled-components.js